function CryptoSliderCard({data,icon}) {
    const isPositiveChangePercent = parseFloat(data?.ticker?.ticker?.price_change_percent) > 0;
    const price = parseFloat(data?.ticker?.ticker?.last);
    const formattedPrice = price < 1 ? price.toFixed(6) : price.toFixed(2);
    
    return(
        <div className="bg-dark-background/50 backdrop-blur-sm hover:bg-dark-backgroundOnDark transition-all duration-300 px-6 py-5 rounded-xl border border-dark-line/30 hover:border-primary/30 group">
            <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-dark-backgroundOnDark/50 flex items-center justify-center p-1 group-hover:bg-primary/10 transition-colors">
                        <img className="w-full h-full rounded-full object-contain" src={icon} alt={data?.base_unit} />
                    </div>
                    <div>
                        <p className="text-surface-main font-bold text-base">{data?.base_unit.toUpperCase()}</p>
                        <p className="text-secondaryTwo text-xs">{data?.name}</p>
                    </div>
                </div>
                <div className={`px-2 py-1 rounded-md text-xs font-medium ${isPositiveChangePercent ? "bg-success/10 text-success" : "bg-danger/10 text-danger"}`}>
                    <div className="flex items-center">
                        {isPositiveChangePercent ? (
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" />
                            </svg>
                        ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M12 13a1 1 0 100 2h5a1 1 0 001-1v-5a1 1 0 10-2 0v2.586l-4.293-4.293a1 1 0 00-1.414 0L8 9.586l-4.293-4.293a1 1 0 00-1.414 1.414l5 5a1 1 0 001.414 0L11 9.414 14.586 13H12z" clipRule="evenodd" />
                            </svg>
                        )}
                        {data?.ticker?.ticker?.price_change_percent}
                    </div>
                </div>
            </div>
            
            <div className="mt-3">
                <p className="text-surface-main font-bold text-xl">{data?.quote_unit.toUpperCase()} {formattedPrice}</p>
                <p className="text-secondaryTwo text-xs mt-1">
                    Hacim: {parseFloat(data?.ticker?.ticker?.volume).toLocaleString()} {data?.quote_unit.toUpperCase()}
                </p>
            </div>
            
            <div className="mt-4">
                <a 
                    href={`https://exchange.gmskripto.com/protrade/${data?.id}`}
                    className="block w-full py-2 text-center text-sm bg-primary/10 hover:bg-primary/20 text-primary rounded-md transition-colors"
                >
                    İşlem Yap
                </a>
            </div>
        </div>
    )
}

export { CryptoSliderCard}
